import { render, staticRenderFns } from "./DiscoverSvg.vue?vue&type=template&id=2c505aae&scoped=true&"
import script from "./DiscoverSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiscoverSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c505aae",
  null
  
)

export default component.exports